import React, { FunctionComponent, useState } from "react";
import {
  Typography,
  Grid,
  Card,
  CardContent,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  InputBase
} from "@material-ui/core";
import IconButton from '@material-ui/core/IconButton';
import Paper from "@material-ui/core/Paper";
import Switch from "@material-ui/core/Switch";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SearchIcon from "@material-ui/icons/Search";
import { useServiceStyles } from "../useServiceStyles";
import { api } from "../../../api";
import { SnackBar } from "../../SnackBar";
import { PosServiceTableList } from "./PosServiceTableList";

type PosServiceProps = {
  serviceData: any;
};

export const PosServices: FunctionComponent<PosServiceProps> = ({
  serviceData
}) => {
  const classes = useServiceStyles();
  const [serviceDetails, setServiceDetails] = React.useState(serviceData);
  const [posData, setPosData] = React.useState(
    serviceData.services&&serviceData.services.filter((i: any) => i.is_pos === "1")
    );
  const [searchText, setSearchtext] = useState<string | null>("");
  const [statusUpdate, setStatusUpdate] = useState<string>("");
  const [snackbarColor, setSnackbarColor] = useState<string>("#d50000");

  const onCloseSnackbar = () => {
    setStatusUpdate("");
  };

  const handleTerminalService = async (enableValue: boolean, terminalId: any, serviceId: number, selectAll: boolean) => {
    try {
      const store_code = localStorage.getItem('authStoreCode');
      const values = {
        terminal_id: selectAll === true ? null : terminalId,
        store_code: store_code,
        service_id: serviceId,
        is_sync_active:
          enableValue === true ? "1" : "0",
        is_select_all: selectAll
      };

      /* const result = await api.patch(
        `services/status`,
        {},
        values
      ); */
      const serviceResult = await api.get(`stores/${store_code}/services`)
      setSnackbarColor("green");
      setStatusUpdate("Status updated successfully");
      setServiceDetails(serviceResult);
      const filterPosServices = serviceResult.services.filter((i: any) => i.is_pos === "1")
      setPosData(filterPosServices);
    } catch (error) {
      console.log(error);
      setSnackbarColor("red");
      setStatusUpdate("Something went wrong");
    }
  };

  return (
    <div className={classes.root}>
      <SnackBar
        status={statusUpdate}
        onCloseError={onCloseSnackbar}
        color={snackbarColor}
      />
      <Accordion expanded={true}>
        <AccordionSummary
          className={classes.accordionStyle}
          expandIcon={<ExpandMoreIcon style={{ color: "white" }} />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography className={classes.serviceHeading}>Pos-Services</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container>
            <Grid item xs={12}>
              {posData&&posData.map((i: any) => (
                <Card
                  className={classes.serviceCards}
                >
                  <CardContent>
                    <Grid container>
                      <Grid item xs={9}>
                        <Typography variant="h5">
                          {i.display_name}
                        </Typography>
                        <Typography variant="body2" color="textSecondary"
                          style={{ fontSize: "14px" }}
                        >
                          Please click the switch for enabling and disabling
                          this pos service in all terminals.
                                                 </Typography>

                      </Grid>
                      <Grid item xs={3}>
                        <Grid container justify="flex-end">
                          <Switch
                            checked={
                              i.is_sync_active === "1" ? true : false
                            }
                            onClick={() => {
                              handleTerminalService(i.is_sync_active === "1" ? false : true,
                                null, i.service_id, true)
                            }

                            }
                            color="primary"
                            name="status"
                            inputProps={{ "aria-label": "primary checkbox" }}
                          />
                          <Typography variant="h5" className={classes.switchLabels}>
                            {
                              i.is_sync_active === "1" ? "On" : "Off"

                            }
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              ))}
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

      <Grid
        container
        spacing={2}
        direction="row"
        justify="space-between"
        alignItems="center"
        style={{ marginTop: "1em" }}
      >
        <Grid item>
          <Paper className={classes.searchPaper}>
            <InputBase
              className={classes.SearchInput}
              value={searchText}
              placeholder="Search...."
              inputProps={{ "aria-label": "search " }}
              onChange={(event) => setSearchtext(event.target.value)}
            />
            <IconButton aria-label="search">
              <SearchIcon />
            </IconButton>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <PosServiceTableList 
           tableData={
            serviceDetails.terminals &&
                (serviceDetails.terminals.filter((item: any) => {
                  if (searchText) {
                    return item.terminal_name
                      .toUpperCase()
                      .includes(searchText.toUpperCase());
                  }
                  return true;
                }) as Array<object>)
              }
           serviceDetails={serviceDetails}
           handleTerminalService={handleTerminalService}
          />
        </Grid>
      </Grid>
    </div>
  );
};
